module.exports = __webpack_public_path__ + "img/Kreis_gue.4103fa9c.png";